// src/authUserStore.js
let storedUser = null;

export const setAuthUser = (user) => {
  storedUser = user;
};

export const getAuthUser = () => storedUser;

export const clearAuthUser = () => {
  storedUser = null;
};
